// Components
import Section from "../Section/SectionContainer";

// CSS
import styles from "./welcomecarousel.module.scss";

/**
 * Constants
 */

const WelcomeCarousel = (data) => {
    const { welcome_carousel } = data;

    /**
     * Hooks
     */

    return (
        <Section classes={styles["carousel"]}>
            {welcome_carousel.map(function (item, i) {
                return (
                    <img
                        className={styles.image}
                        src={item.url}
                        title={item.name}
                        alt={item.name}
                    ></img>
                );
            })}
        </Section>
    );
};

export default WelcomeCarousel;
